import React, { useContext, useEffect } from 'react';
import BookerContext from '../../context/bookerContext';
import BookerShortContext from '../../context/bookerShortContext';
import VehicleInfo from '../RideComponents/VehicleInfo';
import { isNullValue, isUndefinedValue } from '../../utils/valueType';
import { ReactComponent as InfoIcon } from '../../assets/img/info.svg';
import '../../assets/styles/booker-ride-footer.sass';

const RideFooter = () => {
  const context = useContext(BookerContext);
  const {
    state: {
      rideId,
      tipsValue: { tips_value = null, tips_type = '' } = {},
      isWebBooker,
      fare: { total_amount } = {},
      defaultTips = {},
    } = {},
    updateDefaultTips,
  } = context;
  const { ride, vehicle, rideStatus, isOpenTips, isWebBookerPortrait, setIsOpenTips, togglePopup, toggleTips } =
    useContext(BookerShortContext);

  const DEFAULT_TIP_PERCENT = 20;
  const fare = total_amount ? (total_amount / 100).toFixed(2) : null;
  const isNotValue = isUndefinedValue(tips_value) || isNullValue(tips_value);
  let tipsText = `${isNotValue ? DEFAULT_TIP_PERCENT : tips_value}%`;

  if (defaultTips.default_selected && !rideId) {
    if (defaultTips.default_tip_type === 'amount') {
      tipsText = `$${defaultTips.default_tip.toFixed(2)}`;
    } else {
      tipsText = `${defaultTips.default_tip}%`;
    }
  } else {
    if (tips_type === 'amount' || (defaultTips.default_tip_type === 'amount' && !tips_type)) {
      const convTipsValue = Number.isInteger(tips_value) || tips_value === 0 ? tips_value.toFixed(2) : tips_value;
      tipsText = `$${!isNotValue ? convTipsValue : defaultTips.default_tip.toFixed(2)}`;
    } else if (tips_type === 'percent' || (defaultTips.default_tip_type === 'percent' && !tips_type)) {
      tipsText = `${!isNotValue ? tips_value : defaultTips.default_tip}%`;
    }
  }

  useEffect(() => {
    if (isOpenTips) {
      defaultTips.default_selected = false;
      updateDefaultTips(defaultTips);
      toggleTips();
      setIsOpenTips(false);
    }
  }, [isOpenTips]);

  const openFarePopup = () => {
    togglePopup(true, 'fare');
  };

  const onChangeTips = () => {
    defaultTips.default_selected = false;
    updateDefaultTips(defaultTips);
    toggleTips();
  };

  let isVehicle = vehicle || ride?.vehicle_number;
  if (!(ride && isVehicle && rideStatus === 'enroute')) return <></>;

  return (
    <div className={`footer ${isWebBooker && !isWebBookerPortrait ? 'web-booker-footer' : ''}`}>
      <div className="ride-footer">
        <VehicleInfo />

        <div className="ride-fare">
          <div className="fare">
            Fare: <span className="fare-value">${fare}</span>
            <div className="info-btn" onClick={openFarePopup}>
              <InfoIcon />
            </div>
          </div>
          <div
            className="tips-container"
            {...((!isWebBooker || (isWebBooker && isWebBookerPortrait)) && { onClick: toggleTips })}
          >
            {isWebBooker && !isWebBookerPortrait ? (
              <>
                <span className="tips-title">Tips:</span>
                <span className="tips-value">{tipsText}</span>
                <span className="tips-button" onClick={onChangeTips}>
                  Change
                </span>
              </>
            ) : (
              `Your tip ${tipsText}`
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RideFooter;
